import { BaseURL } from '@src/function.js'

export const api = async function ({method, api, body}) {
  const tokenGet = localStorage.getItem('AuthToken')
  const token = tokenGet.replace(/['"]+/g, '')
  const result = await fetch(`${BaseURL}/api/${api}`, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`,
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: 0
    },
    ...(body ? {
        body: JSON.stringify(body)
      } : "")
  })
  return await result
}

export const apiFile = async function ({api, formData}) {
  const tokenGet = localStorage.getItem('AuthToken')
  const token = tokenGet.replace(/['"]+/g, '')
  const result = await fetch(`${BaseURL}/api/${api}`, {
    method:"POST",
    headers: {
      Authorization: `Bearer ${token}`,
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: 0
    },
    body:formData
  })
  return await result
}